// extracted by mini-css-extract-plugin
module.exports = {"title":"faq_title__Tfa_V","wrapper":"faq_wrapper__LPB0b","title_wrapper":"faq_title_wrapper__CtZoy","active":"faq_active__Cg2GH","desc_wrapper":"faq_desc_wrapper__NcIiJ"};